'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const SubscriptionForm_module = require('../../../SubscriptionForm.module-CQEDilRD.js');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');
const components_forms_TextInput_TextInput = require('../../forms/TextInput/TextInput.cjs.js');

const SubscriptionForm = (_a) => {
  var { inputIsFullWidth = true, fluidInput = false } = _a, props = tslib_es6.__rest(_a, ["inputIsFullWidth", "fluidInput"]);
  const [id] = React.useState(props.inputId || utils_uniqueId.uniqueId("SubscriptionForm-"));
  const [subscribedValue, setSubscribedValue] = React.useState("");
  const inputSize = "medium";
  const inputProps = {
    id,
    isDisabled: props.inputIsDisabled,
    isErrored: !!props.inputError,
    isRequired: props.inputIsRequired,
    isFullWidth: inputIsFullWidth,
    placeholder: props.placeholderText,
    ariaLabel: props.placeholderText,
    size: inputSize,
    onChange: (event) => setSubscribedValue(event.target.value)
  };
  return jsxRuntime.jsx("form", { onSubmit: () => {
    var _a2;
    return (_a2 = props.onSubmit) === null || _a2 === void 0 ? void 0 : _a2.call(props, subscribedValue);
  }, "data-testid": "subscription-form", "data-zds": true, children: jsxRuntime.jsxs("div", { className: SubscriptionForm_module.styles.root, "data-zds": true, children: [jsxRuntime.jsx("div", { className: SubscriptionForm_module.styles.inputField, "data-fluid-input": fluidInput ? true : void 0, "data-zds": true, children: props.renderInput ? props.renderInput(inputProps) : jsxRuntime.jsx(components_forms_TextInput_TextInput.TextInput, Object.assign({}, inputProps)) }), props.renderButton({ size: "medium" })] }) });
};

exports.SubscriptionForm = SubscriptionForm;
//# sourceMappingURL=SubscriptionForm.cjs.js.map
